let discountCode = "";
let availablePoints = 0;
let availablePointsToUse = 0;
let jqFields = {};
let claimCodeValid = false;

$(document).ready(function(){

  initjqFields();
  getDiscountPoints();

  jqFields.submitCheckout.on('click', async function(event){
    event.preventDefault();
    var usePoints = jqFields.usePointsChbox.is(":checked");
    var claim500Points = jqFields.claim500Chbox.is(":checked");
    
    var checkoutUrl = '/checkout';

    if (usePoints || (claim500Points && claimCodeValid)) {
      checkoutUrl += "?discount=" + discountCode;
      await fetch("/discount/" + discountCode);
    }

    window.location.href = checkoutUrl;
  });

  jqFields.usePointsChbox.on('click', function(event){
    if($(this).is(":checked")){
      jqFields.discountSection.show();
      
      if(jqFields.claim500Chbox.is(":checked")){
        jqFields.claim500Chbox.prop( "checked", false );
        jqFields.claimSection.hide();
      }
      
    }else{
      jqFields.discountSection.hide();
    }
  });
  
  jqFields.claim500Chbox.on('click', function(event){
    if($(this).is(":checked")){
      jqFields.claimSection.show();
      
      if(jqFields.usePointsChbox.is(":checked")){
        jqFields.usePointsChbox.prop( "checked", false );
        jqFields.discountSection.hide();
      }
      
    }else{
      jqFields.claimSection.hide();
    }
  });


  jqFields.applyPoints.on('click', function(event){
    requestDiscountCode()
  });

  jqFields.resendOTP.on('click', function(event){
    requestDiscountCode()
  });

  jqFields.redeemPoints.on('click', function(event){
    generateDiscountCode()
  });

  jqFields.redeemCoupon.on('click', function(event){
    console.log("hit");
    generateCouponCode()
  });

  jqFields.applyDiscountCode.on('click', function(event){
    discountCode = $('#discount-code-options')[0].value;
    jqFields.discountCodeSelectedApplied.html(discountCode);
    jqFields.discountCodeSelected.show();
    jqFields.applyDiscountCode.hide();
    jqFields.redeemSection.hide();
  });

  jqFields.discountPointsToUse.bind('keyup mouseup', function(){

    let currentValue = Number(jqFields.discountPointsToUse.val());

    if (currentValue > availablePointsToUse || currentValue < 0) {
      jqFields.discountPointsToUse.val(availablePointsToUse)
    }
    
    if(currentValue == 0){
      jqFields.applyPoints.hide();
    }else{
      jqFields.applyPoints.show();
    }

  });

});

function initjqFields(){

  jqFields.usePointsChbox = $("#use-points-checkbox");
  jqFields.claim500Chbox = $("#claim-500-checkbox");
  jqFields.applyPoints = $(".apply-points");
  jqFields.redeemPoints = $(".redeem-points");
  jqFields.resendOTP = $(".resend-otp");
  jqFields.otpReceived = $("#otp-received");
  jqFields.otp = $("#otp");
  jqFields.applyDiscountCode = $(".apply-discount-code");
  jqFields.discountSection = $("#discount-section");
  jqFields.claimSection = $("#claim-section");
  jqFields.submitCheckout = $('#submitCheckout');
  jqFields.discountPointsToUse = $("#discount-points-to-use");
  jqFields.pointLoader = $(".point-loader");
  
  jqFields.discountCodeApplied = $("#discount-code-applied");
  jqFields.claimCodeApplied = $("#claim-code-applied");
  jqFields.claimCodeError = $("#claim-code-error");
  
  jqFields.discountCode = $("#discount-code");
  jqFields.discountPoints = $("#discount-points");
  jqFields.discountList = $("#discount-list");
  
  jqFields.claimCode = $("#claim-code");
  jqFields.claimCheckboxSection = $("#claim-points-checkbox");

  jqFields.discountOptionList = $('#discount-code-options');
  jqFields.discountListDivs = $('#discount-list-div');

  jqFields.discountCodeSelected = $("#discount-code-selected");
  jqFields.discountCodeSelectedApplied = $("#discount-code-selected-applied");

  jqFields.redeemSection = $("#redeem-section");
  jqFields.couponSection = $("#coupon-section");
  jqFields.couponToUse = $("#coupon-to-use");
  jqFields.couponAmountToUse = $("#coupon-amount-to-use");
  jqFields.couponCode = $("#coupon-code");
  jqFields.redeemCoupon = $("#redeem-coupon");
  jqFields.couponCodeError = $("#coupon-code-error");
  jqFields.couponCodeApplied = $("#coupon-code-applied");
}

async function requestDiscountCode(){

  let subtotalPrice = 0;
  let pointsToUse = jqFields.discountPointsToUse.val()
  let otp = jqFields.otp.val()
  discountCode = window.customerID;


  jqFields.applyPoints.hide();
  jqFields.pointLoader.show();

  fetch(window.HVNS_SERVICE_URL + '/api/members/' + window.customerID + '/discounts/request', {
    method: 'POST',
    headers: {
      'Authorization': window.APP_KEY,
      'Content-Type': "application/json",
      "x-access-token": window.token
    },
    body:JSON.stringify({
      shopify_customer_id: window.customerID,
      amount: pointsToUse,
    }),
  })
  .then(response => response.json())
  .then(data => {
    if (data.success) {
      jqFields.otpReceived.show();
      jqFields.applyPoints.hide();
      jqFields.redeemPoints.show();
      jqFields.resendOTP.show();
    }

    jqFields.pointLoader.hide();

  })
  .catch((error) => {

    console.error('Error:', error);
  	jqFields.pointLoader.hide();

  });
}

async function generateCouponCode(){

  let subtotalPrice = 0;
  let amount = jqFields.couponAmountToUse.val()
  let couponCode = jqFields.couponToUse.val()
  discountCode = window.customerID;

  jqFields.redeemCoupon.hide();
  jqFields.claimCodeError.hide();
  jqFields.pointLoader.show();

  fetch(window.HVNS_SERVICE_URL + '/api/members/' + window.customerID + '/coupons', {
    method: 'POST',
    headers: {
      'Authorization': window.APP_KEY,
      'Content-Type': "application/json",
      "x-access-token": window.token
    },
    body:JSON.stringify({
      shopify_customer_id: window.customerID,
      amount: amount,
      coupon_code: couponCode,
      item_code: "1234"
    }),
  })
  .then(response => response.json())
  .then(data => {
	discountCode = data.data.discount_name || "";
	
    if (data.success) {
      jqFields.couponCodeApplied.show();
      jqFields.couponCode.html(discountCode);
    } else {
      jqFields.pointLoader.hide();
      jqFields.redeemCoupon.show();
      jqFields.couponCodeError.show();
    }
  	jqFields.pointLoader.hide();

  })
  .catch((error) => {

    console.error('Error:', error);
  	jqFields.pointLoader.hide();
    jqFields.redeemCoupon.show();
  });
}

async function generateDiscountCode(){

  let subtotalPrice = 0;
  let pointsToUse = jqFields.discountPointsToUse.val()
    let otp = jqFields.otp.val()
  discountCode = window.customerID;


  jqFields.applyPoints.hide();
  jqFields.redeemPoints.hide();
  jqFields.resendOTP.hide();
  jqFields.applyPoints.hide();
  jqFields.claimCodeError.hide();
  jqFields.pointLoader.show();

  fetch(window.HVNS_SERVICE_URL + '/api/members/' + window.customerID + '/discounts', {
    method: 'POST',
    headers: {
      'Authorization': window.APP_KEY,
      'Content-Type': "application/json",
      "x-access-token": window.token
    },
    body:JSON.stringify({
      shopify_customer_id: window.customerID,
      points_to_use: pointsToUse,
      otp: otp,
    }),
  })
  .then(response => response.json())
  .then(data => {
	discountCode = data.data.discount_name || "";
	
    if (data.success) {
      jqFields.discountCodeApplied.show();
      jqFields.discountCode.html(discountCode);
      jqFields.discountList.hide();
      jqFields.redeemPoints.hide();
      jqFields.resendOTP.hide();
    } else {
      jqFields.pointLoader.hide();
      jqFields.redeemPoints.show();
      jqFields.resendOTP.show();
      jqFields.claimCodeError.show();
    }
  	jqFields.pointLoader.hide();

  })
  .catch((error) => {

    console.error('Error:', error);
  	jqFields.pointLoader.hide();
    jqFields.redeemPoints.show();
    jqFields.resendOTP.show();
  });
}

function getDiscountPoints(){

  fetch(window.HVNS_SERVICE_URL + '/api/members/' + window.customerID, {
    headers: {
      "x-access-token": window.token
    }
  })
  .then(response => response.json())
  .then(data => {

    availablePoints = data.data.customer.total_available_balance;
    availablePointsToUse = availablePoints;
	
    if (availablePoints >= window.CLAIM_POINTS_TO_USE){
      jqFields.claimCheckboxSection.show();
    }

    jqFields.discountPoints.html(availablePoints)
    jqFields.discountPointsToUse.val(availablePointsToUse)
    
    let availableDiscounts = data.data.customer.Discounts;
    let optionList = "<select id='discount-code-options' style='width: 100%'>"
    if (availableDiscounts.length > 0) {
      availableDiscounts.forEach((item, i) => {
        optionList += "<option " + (i == 0 ? "selected" : "") + " value='" +  item.code +"'>" + item.code + " - Discount PHP " + item.amount + "</option>";
      });

      optionList += "</select>";
      jqFields.discountListDivs.append(optionList);
      jqFields.discountList.show();
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });

}